import { render, staticRenderFns } from "./sxqy.vue?vue&type=template&id=851b77c6&scoped=true"
import script from "./sxqy.vue?vue&type=script&lang=js"
export * from "./sxqy.vue?vue&type=script&lang=js"
import style0 from "./sxqy.vue?vue&type=style&index=0&id=851b77c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851b77c6",
  null
  
)

export default component.exports